<template>
  <div class="home">
      <pageTop></pageTop>
      <MobileHome v-if="isMobile()"></MobileHome>
      <PcHome v-else></PcHome>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import PcHome from "./PcHome.vue";
import MobileHome from "./MobileHome.vue";
import pageTop from "@/components/pageTop/pageTop";


// import home from '@/api/home'

export default {
  name: "home",
  components: {pageTop, PcHome,MobileHome},
  data() {
    return {
      marginWidth: this.isMobile()?'10px':'50px', // 初始颜色为透明
      navWidth: this.isMobile()?'40px':'80px', // 初始颜色为透明
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: []
    };
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },

  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>
.text {
  font-weight: bold;
  line-height: 0.1; /* 设置行高为字体大小的1.5倍 */
  letter-spacing: 0.3em; /* 使用em单位，相对于字体大小设置间距 */
  font-family: 'Arial', sans-serif; /* 使用Arial字体，如果没有则使用系统默认无衬线字体 */
}
50%
.home_p{
  font-family: "等线";
  font-size: 16px; /* 设置基础字体大小为16像素，提升可读性 */
  line-height: 1.6; /* 设置较为舒适的行间距，1.6是一个常见且易读的选择 */
  color: #333; /* 使用深灰色作为正文颜色，比纯黑更柔和 */
  text-align: justify; /* 文本两端对齐，使段落看起来更整齐（如果需要的话，有时左对齐也是很好的选择） */
  margin: 0 auto; /* 如果希望整体内容居中，可以设置外边距为自动，这里假设body有固定宽度或max-width */
  max-width: 800px; /* 限制内容最大宽度，提升阅读体验，特别是在宽屏设备上 */
  padding: 10px; /* 添加内边距，使内容与边界有一定的呼吸空间 */
}
.subTitle {
  margin-top: 10px;
}
.subTitle-mobile{
  margin-top: 10px;
  position: relative;
  font-size: 14px;
  letter-spacing: 10px;
}
.video{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}
.text_mobile{
  font-size: 30px;
  margin-bottom: 50px;
}
/deep/ .el-drawer__header {
  /* scoped 下需要使用 /deep/ 或 >>> 来穿透样式 */
  background-color: #FFFFFF;
  font-size: 30px;
  color: #333333;
  font-weight: bold;
}

/deep/ .el-drawer__title {
  color: #333333;
  font-size: 18px;
}
</style>
